export const servicesData = [
    {
        id: 'content-intelligence',
        icon: (
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="12" y1="18" x2="12" y2="12"/>
                <line x1="9" y1="15" x2="15" y2="15"/>
            </svg>
        ),
        title: "Content Intelligence",
        description: "Business content is analyzed and transformed into dual digital twins: Data Twin (structure, facts) and Emotional Twin (sentiment, tone, emotional impact).",
        outcomes: ["Dual digital twins", "Emotional analysis", "Automated transformation"]
    },
    {
        id: 'neural-knowledge-graph',
        icon: (
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="12" cy="12" r="3"/>
                <circle cx="6" cy="6" r="2"/>
                <circle cx="18" cy="6" r="2"/>
                <circle cx="6" cy="18" r="2"/>
                <circle cx="18" cy="18" r="2"/>
                <line x1="12" y1="9" x2="12" y2="6"/>
                <line x1="9" y1="12" x2="6" y2="12"/>
                <line x1="15" y1="12" x2="18" y2="12"/>
                <line x1="12" y1="15" x2="12" y2="18"/>
            </svg>
        ),
        title: "Neural Knowledge Graph",
        description: "Content becomes neurons, emotions and topics become synaptic connections—creating an intelligent graph neural network that understands deep relationships and context.",
        outcomes: ["Graph neural network", "Emotional synaptics", "Context awareness"]
    },
    {
        id: 'realtime-user-profiling',
        icon: (
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
                <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
            </svg>
        ),
        title: "Real-Time User Profiling",
        description: "When users interact, we instantly create their Emotional Digital Twin and Profile Twin, mirroring your content's neural structure to understand their current state.",
        outcomes: ["Moment of intent capture", "User digital twins", "Real-time analysis"]
    },
    {
        id: 'intelligent-adaptation',
        icon: (
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="2" y="3" width="20" height="14" rx="2"/>
                <line x1="8" y1="21" x2="16" y2="21"/>
                <line x1="12" y1="17" x2="12" y2="21"/>
                <path d="M7 8l5 5 5-5"/>
            </svg>
        ),
        title: "Intelligent Adaptation",
        description: "AI navigates the neural network using user twins to discover and dynamically shape content that resonates with their emotional state at the moment of intent.",
        outcomes: ["Dynamic content shaping", "Emotional resonance", "Personalized delivery"]
    }
];
